import { useCallback, useState } from "react";
// import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { TextField, Typography } from "@mui/material";
import * as Yup from "yup";
import { debounce } from "lodash";
import { customersSelector, saveEmployer } from "../../../store/slices/applicationFormSlice";
import regex from "../../../utils/regex";

const LengthOfEmployment = ({ applicationId, disabled }) => {
  const dispatch = useDispatch();
  const customers = useSelector(customersSelector);
  const [allValues, setAllValue] = useState({
    timeOfEmployment: customers?.[0]?.employers[0]?.timeOfEmployment && customers?.[0]?.employers[0]?.timeOfEmployment,
  });
  const [fieldErrors, setFieldErrors] = useState({ timeOfEmployment: "" });

  const validationSchema = Yup.object({
    timeOfEmployment: Yup.string()
      .optional()
      .matches(regex.timeOfEmploymentRegex, {
        message: "Employment length must be up to 1200 months",
      })
      .max(4, "Maximum of 4 digits"),
  });

  const debouncedValidation = useCallback(
    debounce(async (name, value) => {
      try {
        await validationSchema.validateAt(name, { [name]: value });
        setFieldErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      } catch (error) {
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          [name]: error.message,
        }));
      }
    }, 300),
    [],
  );

  const handle = {
    onChangeField: async (e, fieldName) => {
      setAllValue({ ...allValues, [fieldName]: e });
      debouncedValidation(fieldName, e);
    },
    commonEventHandle: (value, name) => {
      if (+value > 0 && +value <= 1200 && +customers[0]?.employers[0]?.[name] !== value) {
        dispatch(
          saveEmployer({
            data: {
              applicationId,
              [name]: value,
              employerId: customers[0]?.employers[0]?._id,
              customer: customers[0]?._id,
            },
          }),
        );
      }
    },
  };

  return (
    <>
      <Typography variant="caption">Time of employment (in months)</Typography>
      <TextField
        fullWidth
        id="timeOfEmployment"
        label="Time of employment"
        variant="filled"
        type="text"
        size="small"
        name="timeOfEmployment"
        disabled={disabled}
        value={allValues?.timeOfEmployment}
        error={fieldErrors?.timeOfEmployment}
        helperText={fieldErrors?.timeOfEmployment}
        onChange={(event) => handle.onChangeField(event?.target?.value, "timeOfEmployment")}
        onBlur={(event) => handle.commonEventHandle(+event?.target?.value, "timeOfEmployment")}
      />
    </>
  );
};

export default LengthOfEmployment;
